module.exports = __webpack_public_path__ + "img/loading.3e3fba61.svg";